import { ROLES } from '@/store/admin'

export default ({ store }) => {
  if (
    store.getters['admin/hasRole']([ROLES.ACCOUNTANT_READ, ROLES.ACCOUNTANT_WRITE]) &&
    !store.getters['swiftMessages/loaded']
  ) {
    return store.dispatch('swiftMessages/loadSwiftMessageTypes')
  }
}
